import { render, staticRenderFns } from "./Prefixes,-Suffixes-&-Meta.md?vue&type=template&id=cf552744&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports